<template>
  <section class="section has-text-centered">
    <div class="container">
      <p class="title is-size-4">Discipline</p>
      <div class="recent-activity">
        <ActivityTimeline
          v-if="targetHistories.length > 0"
          :height="isSmallScreen() ? 150 : 50"
          :activeDaysData="recentActivityData.activeDaysData"
          :missingDaysData="recentActivityData.missingDaysData"
        />
      </div>
      <br />
      <br />
      <PracticeStats
        :totalPractice="practiceDaysCount"
        :totalSkipped="skipDaysCount"
        :maxStreak="maxStreak"
        :maxGap="maxGap"
      />
      <br />
      <br />
      <div class="columns is-mobile is-centered">
        <div class="column is-4-desktop is-6-mobile">
          <div class="doughnut">
            <Doughnut
              v-if="targetHistories.length > 0"
              :values="skipVsPracticeData.values"
              :labels="skipVsPracticeData.labels"
              :colors="skipVsPracticeData.colors"
              :title="skipVsPracticeData.title"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import utils from "../../services/utils";
import ActivityTimeline from "./Charts/ActivityTimeline";
import Doughnut from "./Charts/Doughnut";
import PracticeStats from "./PracticeStats";

export default {
  components: {
    ActivityTimeline,
    Doughnut,
    PracticeStats
  },
  props: ["targetHistories"],
  computed: {
    recentActivityData() {
      // NOTE: This is assuming that the data is ordered by date in ascending order!
      const lastMonthData = this.getLast(this.targetHistories, 15);
      const activeDaysData = lastMonthData
        .filter(th => !!th.target)
        .map(th => ({ x: th.date, y: 1 }));
      const missingDaysData = lastMonthData
        .filter(th => !th.target)
        .map(th => ({ x: th.date, y: 1 }));
      return { activeDaysData, missingDaysData };
    },
    streaks() {
      const days = this.targetHistories.map(th => !!th.target);
      return days.reduce(
        (res, n) => (n ? res[res.length - 1]++ : res.push(0), res),
        [0]
      );
    },
    gaps() {
      const days = this.targetHistories.map(th => !th.target);
      return days.reduce(
        (res, n) => (n ? res[res.length - 1]++ : res.push(0), res),
        [0]
      );
    },
    maxStreak() {
      return Math.max.apply(Math, this.streaks);
    },
    maxGap() {
      return Math.max.apply(Math, this.gaps);
    },
    skipDaysCount() {
      return this.targetHistories.filter(th => !th.target).length;
    },
    practiceDaysCount() {
      return this.targetHistories.filter(th => !!th.target).length;
    },
    skipVsPracticeData() {
      return {
        values: [this.practiceDaysCount, this.skipDaysCount],
        labels: ["Days when practiced", "Days when skipped practice"],
        colors: [utils.colors.green, utils.colors.red],
        title: "Practice vs No Practice"
      };
    }
  },
  methods: {
    getLast(arr, count) {
      return arr.slice(Math.max(arr.length - count, 0));
    },
    isSmallScreen() {
      return window.innerWidth < 650;
    }
  }
};
</script>

<style lang="scss" scoped>
.doughnut {
  max-height: 300px;
  max-width: 300px;
  margin: 0 auto;
}
</style>
